module.exports = __webpack_public_path__ + "static/media/edit.d8e3950a.svg";